<template>
    <v-select v-model="facility" :items="selectFacility" label="Facility Name">
    </v-select>
</template>

<script>
  export default {
    name: 'FacilitySelector',
    props: {
      value: String
    },
    watch: {
      value () {
        if(this.facility!==this.value){
          this.facility = this.value
        }
      },
      facility (newFacility) {
        this.$emit('input', newFacility)
      },
      selectFacility (newSelectFacility) {
        if (!this.facility) { // When list updated and facility is null, add the first entry as default
          this.facility = newSelectFacility[0]
        }
      }
    },
    beforeMount () {
      if (!!this.value) {
        this.facility = this.value
      }
      if (!this.facility) {
        this.facility = this.selectFacility[0]
      }
    },
    data () {
      return {
        facility: null
      }
    },
    computed: {
      selectFacility() {
        if (!this.$store.state.facilityStore.facilityList) return [{id: 1, name: 'loading'}]
        let output = []
        for (let i in this.$store.state.facilityStore.facilityList) {
          output.push(this.$store.state.facilityStore.facilityList[i].facility_name)
        }
        return output
      }
    }
  }
</script>

<style scoped>

</style>
